import {CSSProperties, FC} from 'react';


export interface IIconEditNissanProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconEditNissan: FC<IIconEditNissanProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M6.4 16.952h3.392a.821.821 0 0 0 .568-.22l5.536-5.28 2.272-2.119a.744.744 0 0 0 .237-.54.744.744 0 0 0-.237-.542l-3.392-3.268a.82.82 0 0 0-.568-.226.82.82 0 0 0-.568.226l-2.256 2.156-5.552 5.28a.744.744 0 0 0-.232.54v3.231c0 .421.358.762.8.762Zm7.808-10.354 2.264 2.156-1.136 1.082-2.264-2.156 1.136-1.082ZM7.2 13.272l4.744-4.518 2.264 2.156-4.744 4.518H7.2v-2.156Zm12 5.204H4.8c-.442 0-.8.341-.8.762 0 .42.358.762.8.762h14.4c.442 0 .8-.341.8-.762 0-.42-.358-.762-.8-.762Z" clipRule="evenodd" />
        </svg>
    );
};
